/**
 * @generated SignedSource<<6c85b2f1ad0a1d3b8d190e1d88158b86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ConferenceCallProvider = "HANGOUTS_MEET" | "MS_TEAMS" | "SKYPE_FOR_BUSINESS" | "UNKNOWN" | "WEBEX" | "ZOOM";
import { FragmentRefs } from "relay-runtime";
export type JoinConferenceButton_event$data = {
  readonly conferenceCalls: ReadonlyArray<{
    readonly provider: ConferenceCallProvider;
    readonly url: string;
  }>;
  readonly guid: string;
  readonly " $fragmentType": "JoinConferenceButton_event";
};
export type JoinConferenceButton_event$key = {
  readonly " $data"?: JoinConferenceButton_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"JoinConferenceButton_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JoinConferenceButton_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "guid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ConferenceCall",
      "kind": "LinkedField",
      "name": "conferenceCalls",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "provider",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "6d71ee4d06df655e2c95b551a1df9eea";

export default node;
